export default __webpack_public_path__ + "static/media/team-white.75319361.svg";